import { Box, Typography } from "@mui/material";
import { COLOR } from "../../../../utils/colors";
import { VIEW } from "../../../../utils/breakpoint";
import EditBuildingForm from "../_form/edit";
import { parseAsBoolean, useQueryState } from "nuqs";
import { useParams } from "react-router-dom";
import { useGetBuildingDetail } from "../../../../hooks/config-page";

export default function ConfigBuildingDetailPage() {
  const [isEditMode, setIsEditMode] = useQueryState('edit', parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: true }))

  const { id } = useParams<{ id: string }>();
  const { data } = useGetBuildingDetail(id || '')

  const building = data?.data.building;
  
  const onSuccess = (buildingId: string) => {
    // Navigate to building detail page after successful edit
    setIsEditMode(false)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Detail Building
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: COLOR.neutral[900],
            opacity: 0.6,
          }}
        >
          {building?.building_name || 'Loading...'}
        </Typography>
        <Box sx={(theme) => ({
          display: 'flex',
          gap: '12px',
          marginTop: '24px',
          [theme.breakpoints.down(VIEW.TABLET)]: {
            flexDirection: 'column'
          }
        })}>
          <EditBuildingForm
            editMode={isEditMode}
            onSuccess={(buildingId) => onSuccess?.(buildingId)}
            defaultData={building}
            onChangeEditMode={(editMode) => setIsEditMode(editMode)}
          />
        </Box>
      </Box>
    </Box>
  )
}